import { render, staticRenderFns } from "./sub-service-provider.vue?vue&type=template&id=b23cd4e8&scoped=true&"
import script from "./sub-service-provider.vue?vue&type=script&lang=js&"
export * from "./sub-service-provider.vue?vue&type=script&lang=js&"
import style0 from "./sub-service-provider.vue?vue&type=style&index=0&id=b23cd4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23cd4e8",
  null
  
)

export default component.exports